import React from 'react';
import { Search, Filter, X } from 'lucide-react';
import { useMarkup } from '../contexts/MarkupContext';

const MarkupFilters: React.FC = () => {
  const { state, actions } = useMarkup();
  const { filters } = state;

  const statusOptions = [
    { value: 'all', label: 'Todos os Status' },
    { value: 'active', label: 'Apenas Ativos' },
    { value: 'inactive', label: 'Apenas Inativos' },
  ];

  const typeOptions = [
    { value: 'all', label: 'Todos os Tipos' },
    { value: 'percentage', label: 'Percentual' },
    { value: 'fixed_value', label: 'Valor Fixo' },
  ];

  const targetOptions = [
    { value: 'all', label: 'Todos os Alvos' },
    { value: 'adult_price', label: 'Preço Adulto' },
    { value: 'boarding_tax', label: 'Taxa de Embarque' },
    { value: 'total_price', label: 'Preço Total' },
  ];

  const hasActiveFilters = 
    filters.status !== 'all' ||
    filters.type !== 'all' ||
    filters.target !== 'all' ||
    filters.search !== '';

  return (
    <div className="card" style={{ marginBottom: '20px' }}>
      <div style={{ 
        display: 'flex', 
        alignItems: 'center', 
        justifyContent: 'space-between',
        marginBottom: '16px' 
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <Filter size={18} />
          <h4 style={{ margin: 0 }}>Filtros</h4>
          {hasActiveFilters && (
            <span style={{
              background: 'var(--color-blue)',
              color: 'white',
              padding: '2px 8px',
              borderRadius: '12px',
              fontSize: 'var(--font-size-12)',
              fontWeight: 500,
            }}>
              Ativo
            </span>
          )}
        </div>
        
        {hasActiveFilters && (
          <button
            onClick={actions.resetFilters}
            className="btn btn-secondary"
            style={{ padding: '6px 12px' }}
            title="Limpar filtros"
          >
            <X size={14} />
            Limpar
          </button>
        )}
      </div>

      <div style={{ 
        display: 'grid', 
        gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', 
        gap: '16px',
        marginBottom: '16px' 
      }}>
        <div className="form-group">
          <label className="form-label">Status</label>
          <select
            value={filters.status}
            onChange={(e) => actions.setFilters({ status: e.target.value as any })}
            className="form-select"
          >
            {statusOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Tipo</label>
          <select
            value={filters.type}
            onChange={(e) => actions.setFilters({ type: e.target.value as any })}
            className="form-select"
          >
            {typeOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>

        <div className="form-group">
          <label className="form-label">Aplicado em</label>
          <select
            value={filters.target}
            onChange={(e) => actions.setFilters({ target: e.target.value as any })}
            className="form-select"
          >
            {targetOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </div>
      </div>

      <div className="form-group" style={{ margin: 0 }}>
        <label className="form-label">Busca</label>
        <div style={{ position: 'relative' }}>
          <Search 
            size={16} 
            style={{ 
              position: 'absolute', 
              left: '12px', 
              top: '50%', 
              transform: 'translateY(-50%)',
              color: 'var(--color-darkgray)'
            }} 
          />
          <input
            type="text"
            value={filters.search}
            onChange={(e) => actions.setFilters({ search: e.target.value })}
            className="form-input"
            placeholder="Buscar por nome, criador, aeroportos..."
            style={{ paddingLeft: '40px' }}
          />
        </div>
      </div>
    </div>
  );
};

export default MarkupFilters;